const USDT = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#50AF95" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3254 10.9036C11.2513 10.9092 10.8689 10.932 10.0157 10.932C9.33718 10.932 8.8554 10.9116 8.68638 10.9036C6.06406 10.7883 4.10673 10.3318 4.10673 9.78523C4.10673 9.23868 6.06406 8.78281 8.68638 8.6656V10.449C8.85787 10.4613 9.3489 10.4903 10.0275 10.4903C10.8417 10.4903 11.2495 10.4564 11.3229 10.4496V8.66684C13.9397 8.78343 15.8927 9.23991 15.8927 9.78523C15.8927 10.3305 13.9403 10.787 11.3229 10.903L11.3254 10.9036ZM11.3254 8.48239V6.88655H14.9772V4.45299H5.03451V6.88655H8.68576V8.48178C5.718 8.61811 3.48616 9.20598 3.48616 9.91045C3.48616 10.6149 5.718 11.2022 8.68576 11.3391V16.453H11.3247V11.3373C14.2857 11.2009 16.5139 10.6137 16.5139 9.90983C16.5139 9.20598 14.2876 8.61872 11.3247 8.48178L11.3254 8.48239Z"
      fill="white"
    />
  </svg>
);
export default USDT;
